import { IRootState } from '../../../store'
import { IPatientMedication } from '../store/patientMedications.types'

export const getPatientMedicationSelector = (state: IRootState): IPatientMedication | null =>
  state.patientMedications.patientMedication
